<template>
  <footer class="bg-black px-4 py-8">
    <div
      class="mx-auto flex w-desktop max-w-screen-xl items-end justify-between"
    >
      <div class="w-1/3 space-y-4">
        <a :href="mainPageLink">
          <img
            src="./assets/freedom-travel-white-green-logo.svg"
            alt="aviata.kz"
            width="190"
            height="40"
          />
        </a>
        <ul class="space-y-1 text-base">
          <li>
            <a
              :href="getFooterLink(env.AVIATA_ABOUT_URL)"
              class="text-sm text-white hover:text-white"
            >
              {{ $t('footer.about') }}
            </a>
          </li>
          <li>
            <a
              :href="getFooterLink(env.AVIATA_AGREEMENT_URL)"
              class="text-sm text-white hover:text-white"
            >
              {{ $t('footer.public-offer') }}
            </a>
          </li>
          <li>
            <a
              :href="getJobsLink()"
              class="text-sm text-white hover:text-white"
            >
              {{ $t('footer.vacancies') }}
            </a>
          </li>
          <li>
            <a
              :href="getFooterLink(env.AVIATA_CONTACTS_URL)"
              class="text-sm text-white hover:text-white"
            >
              {{ $t('footer.contacts') }}
            </a>
          </li>
        </ul>
      </div>
      <div class="flex w-1/3 flex-col space-y-4 text-sm">
        <img src="./assets/iata.svg" alt="IATA" width="42" height="26" />
        <p class="w-3/4 font-bold text-white">
          {{ $t('footer.iata.title') }}
        </p>
        <p class="w-3/4 text-white">
          {{ $t('footer.iata.subtitle') }}
        </p>
      </div>
      <div class="w-1/3 space-y-4">
        <div class="flex w-3/5 space-x-5">
          <a
            href="https://instagram.com/freedomtravelkz"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            <img
              src="./assets/social/instagram-icon.svg"
              :alt="$t('footer.social.inst.img-alt')"
              width="32"
              height="32"
            />
          </a>
          <a
            href="https://youtube.com/@freedomtravelkz"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            <img
              src="./assets/social/youtube-icon.svg"
              :alt="$t('footer.social.yt.img-alt')"
              width="32"
              height="32"
            />
          </a>
          <a
            href="https://facebook.com/freedomtravel.me"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            <img
              src="./assets/social/facebook-icon.svg"
              :alt="$t('footer.social.fb.img-alt')"
              width="32"
              height="32"
            />
          </a>
          <a
            href="https://twitter.com/Aviatakz"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            <img
              src="./assets/social/twitter-icon.svg"
              :alt="$t('footer.social.tw.img-alt')"
              width="32"
              height="32"
            />
          </a>
        </div>
        <div class="flex items-center space-x-2">
          <a
            href="https://astanahub.com/"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            <picture>
              <source srcset="./assets/astana-hub.webp" type="image/webp" />
              <source srcset="./assets/astana-hub.png" type="image/png" />
              <img
                src="./assets/astana-hub.png"
                alt="Astana Hub"
                width="88"
                height="32"
              />
            </picture>
          </a>
          <picture>
            <source srcset="./assets/deposit-photos.webp" type="image/webp" />
            <source srcset="./assets/deposit-photos.png" type="image/png" />
            <img
              src="./assets/deposit-photos.png"
              alt="Depositphotos Logo"
              width="109"
              height="18"
            />
          </picture>
        </div>
        <div class="flex w-3/4 flex-col space-y-4">
          <p class="text-sm text-white">
            {{
              $t('footer.copyright', {
                currentYear: CURRENT_YEAR,
              })
            }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
  import { env } from '@shared/config';
  import { NavigationLib } from '@shared/lib';
  import { injectAppContext } from '@shared/app-context';
  import { AppLocale } from '@shared/i18n';
  import type { URLString } from '@shared/types';

  const { locale } = injectAppContext();
  const mainPageLink = NavigationLib.buildURL({ locale, path: '' });
  const CURRENT_YEAR = new Date().getFullYear();

  const getFooterLink = (url: URLString) => {
    return NavigationLib.buildURL({ base: url, locale, path: '' }); // Use empty path to just get localized link
  };

  const getJobsLink = () => {
    /**
     * Jobs lending implemented on Tilda and to localize it we need to add -kz to path
     */
    if (locale === AppLocale.KK) {
      return `${env.AVIATA_JOBS_URL}-kz`;
    }

    return env.AVIATA_JOBS_URL;
  };
</script>
